function ifRightToLeft(){
    return localStorage.getItem("locale") == 'iw' || localStorage.getItem("locale") == 'ar';
}
function ifLeftToRight(){
    return !ifRightToLeft();
}
export {ifRightToLeft, ifLeftToRight};